export const getAccessLevelClass = (accessType, rowUser) => {
  if (rowUser && rowUser.builderStatus === 'ADMIN') {
    return 'access-tier--builder-admin';
  }
  switch (accessType) {
    case 'OWNER':
      return 'access-tier--owner';
    case 'VIEWER':
      return 'access-tier--viewer';
    case 'DEMO':
      return 'access-tier--demo';
    case 'SALES_DEMO':
      return 'access-tier--sales-demo';
    default:
      return 'access-tier--none';
  }
};

export const getAccessColor = (accessType, rowUser) => {
  if(rowUser && rowUser.builderStatus === 'ADMIN') {
    return 'var(--access-tier-builder-bg)';
  }
  switch (accessType) {
    case 'OWNER':
      return 'var(--access-tier-owner-bg)';
    case 'VIEWER':
      return 'var(--access-tier-viewer-bg)';
    case 'DEMO':
      return 'var(--access-tier-demo-bg)';
    case 'SALES_DEMO':
      return 'var(--access-tier-sales-bg)';
    default:
      return 'var(--access-tier-none-bg)';
  }
};

export const getReadableAccessLevel = (accessType, rowUser, isMobile) => {
  if(rowUser && rowUser.builderStatus === 'ADMIN') {
    return isMobile ? 'OWNER' : 'BUILDER ADMIN';
  }
  switch (accessType) {
    case 'OWNER':
      return isMobile ? 'ADMIN' : 'CAMERA ADMIN';
    case 'VIEWER':
      return isMobile ? 'FULL' : 'FULL ACCESS';
    case 'DEMO':
      return isMobile ? 'LIVE' : 'LIVE VIEW ONLY';
    case 'SALES_DEMO':
      return isMobile ? 'DEMO' : 'SALES DEMO';
    default:
      return isMobile ? 'NONE' : 'NO ACCESS';
  }
}; 